var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgApprove = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 20,
  x: 2,
  y: 2,
  fill: "#00BB8E",
  rx: 10
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#00BB8E",
  fillRule: "evenodd",
  d: "M16.932 8.65c.33.342.32.888-.024 1.218l-5.979 5.747-3.837-3.688a.862.862 0 1 1 1.195-1.243l2.642 2.54 4.784-4.599a.86.86 0 0 1 1.22.024",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M16.569 8.91a.79.79 0 0 1-.022 1.124l-5.539 5.3-3.554-3.402a.79.79 0 0 1-.023-1.123.8.8 0 0 1 1.13-.023l2.447 2.342 4.432-4.24a.8.8 0 0 1 1.129.022",
  clipRule: "evenodd"
})));
export default SvgApprove;